import React from "react";
import { projects, smallProjects, profile } from "./content";
import { Arrow } from "./Icons";
import ProjectArt from "./ProjectArt";
import SiteMeta from "./SiteMeta";
import { ContactInvitation } from "./Home";

export default function Projects() {
  return (
    <>
      <SiteMeta
        title="Projects"
        path="/projects"
        description="Explore NeoVibe, Skuld, and draupnir: developer tools, offline-first task management, and self-hosted package distribution by Hunter Grey."
      />
      <header className="page-intro">
        <h1>
          Things I’m building<span>.</span>
        </h1>
        <p>
          Most of my projects start with something I want to use myself. These
          are the ones I’m spending time on.
        </p>
      </header>
      <nav className="project-jump-links" aria-label="Jump to a project">
        {projects.map((project) => (
          <a key={project.id} href={`#${project.id}`}>
            {project.name}
            <span>↓</span>
          </a>
        ))}
      </nav>
      <div className="project-details">
        {projects.map((project) => (
          <section
            className="project-detail"
            id={project.id}
            key={project.id}
            tabIndex={-1}
            aria-labelledby={`${project.id}-title`}
          >
            <div className="project-detail-overview">
              <div>
                <span className="project-category">{project.category}</span>
                <h2 id={`${project.id}-title`}>{project.name}</h2>
                <p className="project-standfirst">{project.summary}</p>
                <p>{project.description}</p>
                <ul className="stack-list" aria-label="Built with">
                  {project.stack.map((technology) => (
                    <li key={technology}>{technology}</li>
                  ))}
                </ul>
                <a
                  className="button button-outline"
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View repository <Arrow diagonal />
                </a>
              </div>
              <ProjectArt project={project.id} />
            </div>
            <dl className="project-facts">
              {project.details.map(([term, detail]) => (
                <div key={term}>
                  <dt>{term}</dt>
                  <dd>{detail}</dd>
                </div>
              ))}
            </dl>
            <p className="project-focus">
              <span>Current focus</span>
              {project.focus}
            </p>
          </section>
        ))}
      </div>
      <section className="small-projects" aria-labelledby="small-title">
        <div className="section-heading">
          <h2 id="small-title">Also on the workbench</h2>
          <a
            className="text-link"
            href={profile.gitlab}
            target="_blank"
            rel="noopener noreferrer"
          >
            Browse GitLab <Arrow diagonal />
          </a>
        </div>
        <div>
          {smallProjects.map((project) => (
            <article className="small-project" key={project.name}>
              <h3>{project.name}</h3>
              <p>{project.description}</p>
              <span>{project.detail}</span>
            </article>
          ))}
        </div>
      </section>
      <ContactInvitation />
    </>
  );
}
